<template>
  <div class="s-overlap-strips__strip">
    <div class="s-overlap-strips__conts">
      <div class="s-overlap-strips__row">
        <div class="s-wizard__results__txt">
          <h2 class="s-wizard__results__txt__header">{{ data.title }}</h2>
          <div class="s-wizard__results__txt__wrp">
            <div class="s-wizard__results__txt__left">
              <div class="s-wizard__results__txt__box">
                <h3>{{ data.suggestions[0].title }}</h3>
                <div v-html="data.suggestions[0].text"></div>
                <a
                  v-if="data.suggestions[0].link"
                  :href="data.suggestions[0].link.url"
                  class="btn-clear">
                  <span>{{ data.suggestions[0].link.label }}</span>
                  <i class="icon-arrow-right"></i>
                </a>
              </div>
            </div>
            <div
              v-if="data.suggestions[1]"
              class="s-wizard__results__txt__plus">
              <img src="/imgs/icons/plus.svg" alt="plus" />
            </div>
            <div
              v-if="data.suggestions[1]"
              class="s-wizard__results__txt__right">
              <div class="s-wizard__results__txt__box">
                <h3>{{ data.suggestions[1].title }}</h3>
                <div v-html="data.suggestions[1].text"></div>
                <a
                  v-if="data.suggestions[1].link"
                  :href="data.suggestions[1].link.url"
                  class="btn-clear">
                  <span>{{ data.suggestions[1].link.label }}</span>
                  <i class="icon-arrow-right"></i>
                </a>
              </div>
            </div>
          </div>

          <a
            v-if="data.contactButton"
            :href="data.contactButton.url"
            class="btn s-wizard__results__txt__btn">
            <span>{{ data.contactButton.label }}</span>
          </a>

          <!--disclaimer-->
          <div v-if="data.disclaimerText" class="b-disclaimer">
            <div class="b-disclaimer__cont">
              <div class="b-disclaimer__item">
                <div class="b-disclaimer__label">
                  {{ data.disclaimerTitle }}
                </div>
                <div
                  class="b-disclaimer__txt"
                  v-html="data.disclaimerText"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      required: true,
      type: Object,
    },
  },
}
</script>
